<template>
	<v-menu rounded="lg" :close-on-content-click="false" open-on-hover bottom left nudge-bottom="20">
		<template v-slot:activator="{ on, attrs }">
			<div
				v-on="on"
				v-bind="attrs"
				:class="{ 'is-locked-by-collaborator': isLockedByCollaborator }"
				class="locked-indication display-flex flex-row flex-align-center px-2"
			>
				<SIcon class="lock-icon" name="personal-space" width="10" height="15" />
				<h3 :class="{ 'is-locked-by-collaborator': isLockedByCollaborator }" class="reg mx-1 text-no-wrap">Step locked</h3>
				<SIcon name="installation-tab-info" width="12" height="14" />
			</div>
		</template>
		<LockedStepBy :lockedCollaboratorName="lockedCollaboratorName" />
	</v-menu>
</template>

<script>
import LockedStepBy from '@/components/BlockEditor/LockedStep/LockedStepBy.vue';
export default {
	name: 'LockedStepByMenu',
	components: { LockedStepBy },
	props: {
		lockedCollaboratorName: { type: String },
	},
	computed: {
		isLockedByCollaborator() {
			return this.lockedCollaboratorName?.length > 0;
		},
	},
};
</script>

<style scoped lang="scss">
.locked-indication {
	border-radius: 5px;
	background: #c1f1ee;
	&.is-locked-by-collaborator {
		background: #727998;
		::v-deep {
			circle,
			path {
				stroke: var(--white) !important;
			}
			path,
			line {
				fill: var(--white) !important;
			}
		}
	}
}

.is-locked-by-collaborator {
	color: var(--white);
}
</style>
